import { render, staticRenderFns } from "./GCheckboxForm.vue?vue&type=template&id=401b62aa&"
import script from "./GCheckboxForm.vue?vue&type=script&lang=ts&"
export * from "./GCheckboxForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports